import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconVisa = props => (
  <SvgIcon {...props} viewBox="0 0 32 18">
    <defs>
      <linearGradient id="b" x2="50%" x1="50%" y2="100%">
        <stop stopColor="#FCFDFD" offset="0" />
        <stop stopColor="#EAEAEA" offset="1" />
      </linearGradient>
    </defs>
    <g fillRule="evenodd" fill="none">
      <rect id="a" rx="2" height="18" width="32" y="0" x="0" fillRule="evenodd" />
      <rect rx="2" height="17.8" width="31.8" stroke="#BDBDBD" y=".1" x=".1" strokeWidth=".2" />
      <path fill="#055CA2" d="m21.079 6.2846l-0.245 1.4699-0.161-0.0782c-0.332-0.1374-0.758-0.2692-1.346-0.2597-0.703 0-1.029 0.3014-1.029 0.5832-0.005 0.318 0.38 0.5273 1.009 0.8406 1.037 0.4841 1.517 1.0712 1.51 1.8426-0.014 1.408-1.241 2.317-3.131 2.317-0.807-0.008-1.584-0.173-2.004-0.362l0.253-1.518 0.231 0.108c0.591 0.253 0.974 0.356 1.693 0.356 0.517 0 1.072-0.208 1.076-0.662 0.004-0.297-0.232-0.51-0.932-0.842-0.682-0.3242-1.585-0.8676-1.576-1.8419 0.011-1.3181 1.263-2.2381 3.04-2.2381 0.697 0 1.255 0.1472 1.612 0.2846zm3.065-0.1753v0.0002h1.375l1.481 6.7815h-1.692l-0.212-1.039h-2.274l-0.37 1.039h-1.904l2.665-6.2041c0.189-0.4415 0.5-0.5776 0.931-0.5776zm-0.817 4.3857h1.493c-0.073-0.339-0.417-1.958-0.417-1.958l-0.121-0.5844c-0.091 0.2546-0.249 0.6648-0.239 0.647 0 0-0.568 1.5054-0.716 1.8954zm-13.726 0.263l1.7981-4.6487h1.904l-2.856 6.7817h-1.9037l-1.5886-5.9065c1.1412 0.5875 2.1597 1.7601 2.4878 2.8439l0.1584 0.9296zm3.2791 2.133l1.11-6.7817h1.798l-1.11 6.7817h-1.798z" />
      <path fill="#FFC500" d="m5 6.1093v0.1095c2.2561 0.5612 3.8225 1.9799 4.4426 3.6097l-0.6519-3.1404c-0.1089-0.4292-0.4387-0.5638-0.8289-0.5787l-2.9618-0.0001z" />
    </g>
  </SvgIcon>
);

export default IconVisa;



// WEBPACK FOOTER //
// ./src/components/icons/IconVisa.js